import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-pr': {
			// /tai-chi-walking-f-pr?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_print_tai_chi_f_bmi_post_funnel~1
			funnel: {
				id: 'ob-female-tai-chi-walking-pr-bmi-post',
				locale: ['en'],
			},
		},
	},
]

export default config
